import { Flex } from "styles/utility-components";

import UIcon from "lib/icons/untitled_ui/UIcon";

export default function CentredSpinner({ label }: { label?: string }): JSX.Element {
  return (
    <Flex alignItems="center" justifyContent="center" width="100%" height="100%" aria-label={label}>
      <UIcon icon="spinner" size={32} />
    </Flex>
  );
}
